import { RaceWithParticipants } from '@/backend/domain/race/getRace';
import { RaceStatus } from '@/backend/domain/models/race';

const raceStatusMap: Record<RaceStatus, string> = {
    DRAFT: "Entwurf",
    REGISTRATION_OPEN: "Anmeldung offen",
    REGISTRATION_CLOSED: "Anmeldung geschlossen",
    COMPLETED: "Abgeschlossen",
};

interface RaceStatsProps {
    race: RaceWithParticipants;
}

export function RaceStats({ race }: RaceStatsProps) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
                <div className="text-sm tracking-widest text-slate-600 mb-2">DATUM</div>
                <div className="text-lg">
                    {new Date(race.date).toLocaleDateString("de-DE", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                    })}
                </div>
            </div>
            <div>
                <div className="text-sm tracking-widest text-slate-600 mb-2">STATUS</div>
                <div className="text-lg">{raceStatusMap[race.status]}</div>
            </div>
            <div>
                <div className="text-sm tracking-widest text-slate-600 mb-2">TEILNEHMER</div>
                <div className="text-lg">{race._count.participants}</div>
            </div>
            {race.modes.includes('TEAM') && (
                <div>
                    <div className="text-sm tracking-widest text-slate-600 mb-2">TEAMS</div>
                    <div className="text-lg">{race._count.teams}</div>
                </div>
            )}
        </div>
    );
}
